/** The Fias Forge internal arche's id — the `/a/<id>` route every forge page lives under. */
export const FORGE_ARCHE_ID = 'arche_forge';

/**
 * Minutes without activity after which the platform stops a running forge
 * (the sweep). Mirrors FORGE_IDLE_STOP_MINUTES in `@fias/db-types`, which the
 * client cannot import; the page only uses it to explain an idle stop.
 */
export const FORGE_IDLE_STOP_MINUTES = 30;
